import { DefaultInteractionID } from './index';
import type { InteractionIDContextType } from './index';

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const getInteractionId = (): InteractionIDContextType => DefaultInteractionID;
